import React from 'react';

import classes from './HeaderRow.module.scss';
import { GridTableRow } from '../../../../../../../shared/components/table-components';
import { SortButtons } from '../../../../../../../shared/components/buttons';
import { SortMethods } from '../../../../../../../shared/hooks/useSort';

type HeaderRowProps = {
  sortMethods: SortMethods<'fullName' | 'status'>;
};

const HeaderRow = ({ sortMethods }: HeaderRowProps) => {
  return (
    <GridTableRow variant="unstyled" className={classes.headerRow}>
      <SortButtons
        fieldName="fullName"
        onSort={sortMethods.handleSort}
        getIsActive={sortMethods.getIsSortedBy}
      >
        Customer
      </SortButtons>
      <SortButtons
        fieldName="status"
        onSort={sortMethods.handleSort}
        getIsActive={sortMethods.getIsSortedBy}
      >
        Status
      </SortButtons>
    </GridTableRow>
  );
};

export { HeaderRow };
